import * as React from 'react';
import { FC } from 'react';

import { ILinkWidgetFragment } from 'generated/sanity-graphql';

import { BUTTON_VARIANT } from './constants';
import { StyledButton } from './loyalty-button-widget.styled';

export interface ILoyaltyButtonWidgetProps {
  link: ILinkWidgetFragment;
}

const LoyaltyButtonWidget: FC<ILoyaltyButtonWidgetProps> = ({ link: linkProp }) => {
  const { text, link } = linkProp;

  return (
    <StyledButton data-testid="button-widget" to={link?.locale || ''} variant={BUTTON_VARIANT}>
      {text?.locale}
    </StyledButton>
  );
};

export default LoyaltyButtonWidget;
